import withTranslation from "next-translate/withTranslation"
import { ReactNode } from "react"
import DatePicker, { ReactDatePickerProps } from "react-datepicker"
import { FormGroup, Label } from "reactstrap"

import FAQPopup from "@components/common/faq/FAQPopup"
import { getLocaleToDateFns } from "@services/formatDate"

import FormikElement, { IBaseFormikProps } from "./FormikElement"


interface IProps extends IBaseFormikProps {
  value: string
  labels: Record<string, unknown>
  datePickerProps?: ReactDatePickerProps
}

/**
 * this component provides a Formik-based Date-Selector
 */
class FormikDate extends FormikElement<IProps> {
  public render(): ReactNode {
    const { id, field, form, value, datePickerProps } = this.props
    const labelText = this.labelText()

    return <FormGroup>
      {labelText.length > 0 &&
        <Label for={field.name}>{labelText}
          {this.props.faqpopup && /* set an faq-popup, if given */
            <FAQPopup {...this.props.faqpopup} />
          }
        </Label>
      }

      {this.helpElement()}

      <DatePicker
        className="form-control"
        wrapperClassName={this.hasError() ? 'is-invalid' : null}
        {...datePickerProps}
        dateFormat={"P" + (datePickerProps.showTimeSelect ? ", HH:mm" : "")}
        id={id || field.name}
        locale={getLocaleToDateFns(this.props.i18n.lang)}
        name={field.name}
        onChange={(val, e) => {
          if (datePickerProps?.onChange)
            datePickerProps.onChange(val, e)
          form.setFieldValue(field.name, val)
        }}
        required={this.props.required}
        selected={(value && new Date(value)) || null}
      />

      {this.errorElement()}
    </FormGroup>
  }
}

export default withTranslation(FormikDate, "common")
